// extracted by mini-css-extract-plugin
module.exports = {"container":"error-statement_container__eVa49","headline":"error-statement_headline__rtekc","link":"error-statement_link__G82Wf"};